import { useMemo } from "react"
import type { DuplicateViewFlowActions } from "../helpers/duplicate-view-flow"
import { useAssetViewData } from "./use-asset-view-data"

export function useDuplicateFlow(): DuplicateViewFlowActions {
  const {
    setView,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  } = useAssetViewData()

  return useMemo(() => ({
    setView,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  }), [
    setView,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  ])
}
